/** Cart-edit presentation only. Reads APO rules; never changes controls or totals. */
(function () {
  'use strict';
  if (window.__LP_APO_CART_EDIT_UI__) return;
  window.__LP_APO_CART_EDIT_UI__ = true;
  var CARD_PRICE_ATTRIBUTE = 'data-lp-cart-frame-price';
  var SUMMARY_PRICE_ATTRIBUTE = 'data-lp-cart-frame-summary';
  var pendingItem = null;
  var identities = new WeakMap();
  var timer = null;
  function valuesOf(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'object') {
      return Object.keys(value).map(function (key) {
        return value[key];
      });
    }
    return [value];
  }

  function uniqueStrings(values) {
    return values.reduce(function (result, value) {
      var normalized = String(value || '').trim();
      if (normalized && result.indexOf(normalized) === -1) {
        result.push(normalized);
      }
      return result;
    }, []);
  }

  function getOptionId(option) {
    if (!option) return '';
    return String(
      option.getAttribute('data-option-id') || option.getAttribute('id') || ''
    ).trim();
  }

  function getValueId(valueCard) {
    if (!valueCard) return '';

    var valueId = valueCard.getAttribute('data-value-id');
    if (valueId) return String(valueId).trim();

    var control = valueCard.querySelector('.mw-option__control');
    return control && control.value ? String(control.value).trim() : '';
  }

  function collectSelectedValues(info) {
    var selectedByOption = {};
    var options = info.querySelectorAll(
      '.mw-option[data-option-id], .mw-option[id^="o_"]'
    );

    options.forEach(function (option) {
      var optionId = getOptionId(option);
      if (!optionId) return;

      var selected = [];

      option
        .querySelectorAll(
          'input.mw-option__control:checked, option:checked'
        )
        .forEach(function (control) {
          if (control.value) selected.push(control.value);
        });

      option
        .querySelectorAll('.mw-option__value--selected[data-value-id]')
        .forEach(function (value) {
          selected.push(value.getAttribute('data-value-id'));
        });

      selectedByOption[optionId] = uniqueStrings(selected);
    });

    return selectedByOption;
  }

  function conditionMatches(
    condition,
    response,
    selectedByOption,
    frameOptionId,
    frameValueId
  ) {
    if (!condition || !condition.option_id) return false;

    var optionId = String(condition.option_id);
    var selected =
      optionId === frameOptionId
        ? [frameValueId]
        : selectedByOption[optionId] || [];
    var expected = uniqueStrings(valuesOf(condition.values));
    if (!expected.length) return false;

    var option =
      response && response.options && response.options[optionId]
        ? response.options[optionId]
        : null;
    var inputType = String((option && option.input_type) || '').toLowerCase();
    var isMultiValue =
      inputType.indexOf('multi') === 0 ||
      inputType === 'checkbox' ||
      inputType === 'multiselect';
    var hasMatch = isMultiValue
      ? expected.every(function (value) {
          return selected.indexOf(String(value)) !== -1;
        })
      : expected.some(function (value) {
          return selected.indexOf(String(value)) !== -1;
        });
    var hasExcludedMatch = expected.some(function (value) {
      return selected.indexOf(String(value)) !== -1;
    });
    var operator = String(condition.operator || 'eq').toLowerCase();

    if (
      operator === '!eq' ||
      operator === 'neq' ||
      operator === 'not_eq' ||
      operator === '!=' ||
      operator === 'notin'
    ) {
      return !hasExcludedMatch;
    }

    if (
      operator === 'eq' ||
      operator === '=' ||
      operator === '==' ||
      operator === 'in'
    ) {
      return hasMatch;
    }

    return false;
  }

  function ruleMatches(
    rule,
    response,
    selectedByOption,
    frameOptionId,
    frameValueId
  ) {
    var conditions = valuesOf(rule && rule.conditions);
    if (!conditions.length) return false;

    var frameConditions = conditions.filter(function (condition) {
      return String(condition.option_id || '') === frameOptionId;
    });
    if (!frameConditions.length) return false;

    var matcher = function (condition) {
      return conditionMatches(
        condition,
        response,
        selectedByOption,
        frameOptionId,
        frameValueId
      );
    };

    var frameMatches = frameConditions.some(matcher);
    if (!frameMatches) return false;

    return String(rule.condition_type || 'all').toLowerCase() === 'any'
      ? conditions.some(matcher)
      : conditions.every(matcher);
  }

  function calculateAdjustment(
    response,
    selectedByOption,
    frameOptionId,
    frameValueId
  ) {
    return valuesOf(response && response.rules).reduce(function (total, entry) {
      var rule = entry && entry.rule ? entry.rule : entry;
      if (
        !rule ||
        !ruleMatches(
          rule,
          response,
          selectedByOption,
          frameOptionId,
          frameValueId
        )
      ) {
        return total;
      }

      var price = rule.price || {};
      var amount = Number(price.value);
      if (!Number.isFinite(amount) || amount === 0) return total;

      var mode = String(price.mode || '').toLowerCase();
      if (mode === 'increase') return total + amount;
      if (mode === 'decrease') return total - amount;

      // A "set" rule replaces a total; it is not a Frame Style surcharge.
      return total;
    }, 0);
  }

  function formatNumber(cents, placeholder) {
    var precision = placeholder.indexOf('no_decimals') !== -1 ? 0 : 2;
    var thousands = ',';
    var decimal = '.';

    if (placeholder.indexOf('comma_separator') !== -1) {
      thousands = '.';
      decimal = ',';
    } else if (placeholder.indexOf('space_separator') !== -1) {
      thousands = ' ';
      decimal = ',';
    } else if (placeholder.indexOf('apostrophe_separator') !== -1) {
      thousands = "'";
    }

    var number = (cents / 100).toFixed(precision).split('.');
    var whole = number[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return whole + (number[1] ? decimal + number[1] : '');
  }

  function formatMoney(amount) {
    var init = window.mwApoInit || {};
    var shopCurrency = init.shop_currency || '';
    var activeCurrency =
      (window.Shopify &&
        Shopify.currency &&
        Shopify.currency.active) ||
      shopCurrency;
    var rate = Number(
      window.Shopify && Shopify.currency && Shopify.currency.rate
    );
    if (!Number.isFinite(rate) || rate <= 0) rate = 1;

    var convertedAmount = Math.abs(amount) * rate;
    var cents = Math.round(convertedAmount * 100);
    if (window.LPMoney && typeof window.LPMoney.format === 'function') {
      return window.LPMoney.format(cents, {
        currency: activeCurrency || shopCurrency,
        locale: document.documentElement.lang || 'en'
      });
    }

    var settings = init.settings || {};
    var includeCurrency =
      settings.currency_html_format &&
      settings.currency_html_format !== 'without_currency';
    var moneyFormat = includeCurrency
      ? init.shop_money_with_currency_format
      : init.shop_money_format;

    if (
      activeCurrency === shopCurrency &&
      moneyFormat &&
      moneyFormat.indexOf('<') === -1
    ) {
      var placeholderMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      if (placeholderMatch) {
        return moneyFormat.replace(
          placeholderMatch[0],
          formatNumber(cents, placeholderMatch[1])
        );
      }
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: activeCurrency || shopCurrency || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return (activeCurrency || shopCurrency || '$') + (cents / 100).toFixed(2);
    }
  }

  function formatAdjustment(amount) {
    if (Math.abs(amount) < 0.005) return '';
    return (amount > 0 ? '+' : '-') + formatMoney(amount);
  }

  function hasNativePrice(valueCard) {
    return Array.prototype.some.call(
      valueCard.querySelectorAll('.mw-option__price'),
      function (price) {
        return price.textContent.trim().length > 0;
      }
    );
  }

  function updateCardPrice(valueCard, priceText) {
    var priceWrapper = valueCard.querySelector(
      '[' + CARD_PRICE_ATTRIBUTE + ']'
    );

    if (!priceText || hasNativePrice(valueCard)) {
      if (priceWrapper) priceWrapper.remove();
      return false;
    }

    if (!priceWrapper) {
      var content = valueCard.querySelector('.mw-stack--wide__content');
      if (!content) return false;

      priceWrapper = document.createElement('div');
      priceWrapper.className =
        'mw-stack--wide__content-price lp-frame-rule-price-wrap';
      priceWrapper.setAttribute(CARD_PRICE_ATTRIBUTE, '');

      var price = document.createElement('span');
      price.className = 'mw-text lp-frame-rule-price';
      priceWrapper.appendChild(price);
      content.appendChild(priceWrapper);
    }

    var priceNode = priceWrapper.querySelector('.lp-frame-rule-price');
    if (priceNode && priceNode.textContent !== priceText) {
      priceNode.textContent = priceText;
    }

    return true;
  }

  function isSelected(valueCard) {
    var control = valueCard.querySelector('.mw-option__control');
    return Boolean(
      (control && control.checked) ||
        valueCard.classList.contains('mw-option__value--selected')
    );
  }

  function updateSummary(frameOption, priceText) {
    var summaryPrice = frameOption.querySelector(
      '[' + SUMMARY_PRICE_ATTRIBUTE + ']'
    );

    if (!priceText) {
      if (summaryPrice) summaryPrice.remove();
      return;
    }

    if (!summaryPrice) {
      var selectedTitle = frameOption.querySelector(
        '[data-mw-option-accumulated-title]'
      );
      if (!selectedTitle || !selectedTitle.parentNode) return;

      summaryPrice = document.createElement('span');
      summaryPrice.className = 'mw-text lp-frame-rule-price-summary';
      summaryPrice.setAttribute(SUMMARY_PRICE_ATTRIBUTE, '');
      selectedTitle.parentNode.insertBefore(
        summaryPrice,
        selectedTitle.nextSibling
      );
    }

    var summaryText = '(' + priceText + ')';
    if (summaryPrice.textContent !== summaryText) {
      summaryPrice.textContent = summaryText;
    }
  }

  function optionTitle(option) {
    var title = option.querySelector('.mw-option__title, .mw-text--style-strong');
    if (!title) return '';
    var copy = title.cloneNode(true);
    copy.querySelectorAll('[data-mw-option-accumulated-title], .mw-option__required, [' + SUMMARY_PRICE_ATTRIBUTE + ']').forEach(function (node) { node.remove(); });
    return copy.textContent.replace(/\*/g, '').trim();
  }

  function responseFor(root) {
    var item = identities.get(root);
    var responses = (window.mwApoInit || {}).response || {};
    var optionIds = Array.from(root.querySelectorAll('.mw-option[data-option-id]')).map(getOptionId);
    if (!item || !optionIds.length) return null;
    var candidates = valuesOf(responses).filter(function (response) {
      return response && String(response.product_id) === item.productId &&
        optionIds.every(function (id) { return response.options && response.options[id]; });
    });
    var exact = candidates.filter(function (response) { return String(response.variant_id) === item.variantId; });
    return exact.length === 1 ? exact[0] : candidates.length === 1 ? candidates[0] : null;
  }

  function updateGifts(option) {
    var summary = option.querySelector('[data-mw-option-accumulated-title]');
    if (!summary) return;
    var names = [];
    option.querySelectorAll('.mw-option__value[data-value-id]').forEach(function (card) {
      if (!isSelected(card)) return;
      var label = card.querySelector('.mw-stack--wide__content-title, .mw-option__value-title, .mw-option__value-text');
      if (!label) return;
      var copy = label.cloneNode(true);
      copy.querySelectorAll('.mw-option__price, .mw-option__compare-price, .mw-stack--wide__content-price').forEach(function (node) { node.remove(); });
      var name = copy.textContent.trim();
      if (name) names.push(name);
    });
    if (!names.length && option.querySelector('input.mw-option__control:checked')) return;
    var existing = Array.from(summary.children);
    if (existing.length === names.length && existing.every(function (node, index) {
      return node.classList.contains('lp-cart-gift-name') && node.textContent === names[index];
    }) && (names.length || !summary.textContent.trim())) return;
    var fragment = document.createDocumentFragment();
    names.forEach(function (name) {
      var line = document.createElement('span');
      line.className = 'lp-cart-gift-name';
      line.textContent = name;
      fragment.appendChild(line);
    });
    summary.replaceChildren(fragment);
  }

  function refresh() {
    timer = null;
    document.querySelectorAll('.mw-tingle:not(.mw-option-modal)').forEach(function (root) {
      var title = root.querySelector('.mw-product-info__title');
      if (!title) return;
      if (!identities.has(root)) {
        if (!pendingItem) return;
        identities.set(root, pendingItem);
        pendingItem = null;
        root.classList.add('lp-apo-cart-edit');
      }
      var text = title.textContent
        .replace(/Hand[-\s]*painted\s+Pet\s+Portrait/gi, 'Custom Hand-Painted')
        .replace(/Hand[-\s]*sculpted\s*3D\s+Pet\s+Portrait/gi, 'Custom Hand-Sculpted');
      if (title.textContent !== text) title.textContent = text;
      var response = responseFor(root);
      var selected = collectSelectedValues(root);
      root.querySelectorAll('.mw-option').forEach(function (option) {
        var label = optionTitle(option);
        if (label === 'Matching Pet Gifts') updateGifts(option);
        if (label !== 'Frame Style' || !response) return;
        var optionId = getOptionId(option);
        var summaryText = '';
        option.querySelectorAll('.mw-option__value[data-value-id]').forEach(function (card) {
          var price = formatAdjustment(calculateAdjustment(response, selected, optionId, getValueId(card)));
          var displayed = updateCardPrice(card, price);
          if (displayed && isSelected(card)) summaryText = price;
        });
        updateSummary(option, summaryText);
      });
    });
  }

  function schedule() {
    if (timer !== null) return;
    timer = window.setTimeout(refresh, 60);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-mw-apo-configure-link][data-mw-apo-cart-id]');
    if (!link || !link.getAttribute('data-mw-apo-cart-id')) return;
    pendingItem = {
      productId: link.getAttribute('data-mw-apo-configure-link'),
      variantId: link.getAttribute('data-mw-apo-variant-id') || ''
    };
    schedule();
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.closest('.lp-apo-cart-edit')) schedule();
  });
  ['mwApo::ready', 'mwApo::recalculated', 'mwApo::ON_CHANGE_OPTION'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });
  function observe() {
    new MutationObserver(function (records) {
      // APO rewrites the accumulated line on selection. Normalize gift names
      // in this microtask, before paint, rather than waiting for the 60 ms
      // price refresh. updateGifts is idempotent, so our own mutations settle.
      var giftOptions = new Set();
      records.forEach(function (record) {
        var target = record.target.nodeType === 1
          ? record.target : record.target.parentElement;
        if (!target || !target.closest('.lp-apo-cart-edit')) return;
        var option = target.closest('.mw-option');
        if (option && optionTitle(option) === 'Matching Pet Gifts') {
          giftOptions.add(option);
        }
      });
      giftOptions.forEach(updateGifts);
      if (records.some(function (record) {
        return record.target.nodeType === 1 && record.target.closest('.lp-apo-cart-edit') ||
          Array.from(record.addedNodes).some(function (node) {
            return node.nodeType === 1 && (node.matches('.mw-tingle, .mw-product-info') || node.querySelector('.mw-product-info'));
          });
      })) schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe, { once: true });
})();

